<template>
  <div class="title-bar">
    <div class="left">
      {{ title }}
    </div>
    <div class="right">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.title-bar {
  height: 40px;
  color: #fff;
  display: flex;
  flex-flow: row nowrap;
  background-color: #54a890;
  line-height: 40px;

  .left,
  .right {
    flex: 1;
  }
  .left {
    background-image: url('~@/assets/icon/ico2.png');
    background-repeat: no-repeat;
    padding-left: 40px;
    background-position-y: 7px;
    background-position-x: 10px;
    font-weight: bold;
    font-size: 16px;
  }
  .right {
    flex: 4;
    text-align: right;
    padding-right: 10px;
  }
}
</style>
